import type { FromModel, ModelDefinition } from "@/__main__/data-model.mjs";
import createModel from "@/__main__/data-model.mjs";

export const model = {
  paths: [String],
} satisfies ModelDefinition;

const AdsPathBlacklist = createModel(model);

export default AdsPathBlacklist;

export type AdsPathBlacklist = FromModel<typeof model>;
